import { createContext, useContext, useState } from "react";

const envPassword = process.env.REACT_APP_PASSWORD
const clientEnvPassword = process.env.REACT_APP_CLIENT_PASSWORD
const AuthContext = createContext();
const AUTH_EXPIRES_AT_KEY = "admin_auth_expires_at";
const AUTH_DURATION_MS = 4 * 60 * 60 * 1000;

const getStoredAuthState = () => {
  const expiresAt = Number(localStorage.getItem(AUTH_EXPIRES_AT_KEY));

  if (!Number.isFinite(expiresAt)) return false;

  if (Date.now() >= expiresAt) {
    localStorage.removeItem(AUTH_EXPIRES_AT_KEY);
    return false;
  }

  return true;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(getStoredAuthState);

  const login = (password) => {
    if (password === envPassword || password === clientEnvPassword) {
      localStorage.setItem(
        AUTH_EXPIRES_AT_KEY,
        String(Date.now() + AUTH_DURATION_MS)
      );
      setIsAuthenticated(true);
      return true;
    }
    return false;
  };

  const logout = () => {
    localStorage.removeItem(AUTH_EXPIRES_AT_KEY);
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
